import { useQuery } from '@apollo/client';
import { ApplicantProfileIdentity } from './applicant-profile-identity';
import {
  StaffApplicantProfileIdentityDetailsTermsAndConditionsFieldsFragment,
  StaffApplicantProfileIdentityContainerDocument,
  StaffApplicantProfileIdentityDetailsContactInformationFieldsFragment
} from '../../../../generated';
import { Empty, Skeleton } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';

interface ApplicantProfileIdentityContainerProps {
  applicantId: string;
}

export const ApplicantProfileIdentityContainer: React.FC<ApplicantProfileIdentityContainerProps> = ({ applicantId }) => {
  const navigate = useNavigate();
  const handleEditToggle = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, '/edit');
    navigate(newPath);
  };
  const {
    data: identityData,
    loading: identityLoading,
    error: identityError
  } = useQuery(StaffApplicantProfileIdentityContainerDocument, {
    variables: {
      applicantUserId: applicantId
    }
  });

  if (identityLoading) {
    return <Skeleton active />;
  }

  if (identityError || !identityData?.applicantUser?.personalInformation?.identityDetails || !identityData?.applicantUser?.personalInformation?.nameOnDocumentAssets) {
    return <Empty description="There was an error loading the data. Please try again!" />;
  }

  const hasData =
    identityData.applicantUser.personalInformation.contactInformation !== undefined && identityData.applicantUser.personalInformation.identityDetails !== undefined;
  return (
    <ComponentQueryLoader
      error={identityError}
      loading={identityLoading}
      hasData={hasData}
      hasDataComponent={
        <ApplicantProfileIdentity
          onEdit={handleEditToggle}
          applicantId={identityData.applicantUser.id}
          contactDetails={identityData.applicantUser.personalInformation.contactInformation as StaffApplicantProfileIdentityDetailsContactInformationFieldsFragment}
          identityDetails={identityData.applicantUser.personalInformation.identityDetails}
          termsAndConditions={identityData.applicantUser.termsAndConditions as StaffApplicantProfileIdentityDetailsTermsAndConditionsFieldsFragment[]}
        />
      }
    />
  );
};
